import { convertToValueOpt } from "../utils/SelectUtil";
export const defaultAsSelectPlaceholder = {
    day: "day",
    month: "month",
    year: "year",
};
export const defaultMonthsValueOptions = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
];
export const fullNameMonthsValueOptions = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
export const getNumberValueOption = (start, end) => {
    const days = [];
    for (let i = start; i <= end; i++) {
        days.push(i);
    }
    return convertToValueOpt(days);
};
export const getMonthsValueOptions = (months) => {
    const valueOpts = [];
    months.forEach((month, index) => {
        valueOpts.push({
            value: month,
            label: month,
        });
    });
    return valueOpts;
};
export const getYearValueOptions = (start, end) => getNumberValueOption(start, end);
//# sourceMappingURL=DateTypes.js.map